import React from "react";
import Onboarding from "./redux";
import LoraChecklist from "./LoraChecklist";

export default function Hero({ device, isOnline, onOpenSimulator }) {
  return (
    <div className="">
      {device.profile && device.profile._id !== "" ? (
        <LoraChecklist device={device} />
      ) : (
        <Onboarding
          device={device}
          isOnline={isOnline}
          clientId={device.serial}
          onOpenSimulator={onOpenSimulator}
        />
      )}
    </div>
  );
}
